import {Cross} from '../icons';
import './style.css';
import react from 'react';
import Tippy from '@tippyjs/react';
import {Placement} from 'tippy.js';
import {useStores} from "../../stores/root";
import {observer} from "mobx-react-lite";

export const TooltipContent: react.FC = observer(() => {
    const {onboarding} = useStores()
    return <div>
        <div className="tippy-title">
            <span>{onboarding.getCurrentStepInfo()?.title}</span>
            <span style={{cursor: 'pointer'}} onClick={() => onboarding.skipOnboarding()}><Cross
                color={'white'}/></span>
        </div>
        <span className='tippy-description'>{onboarding.getCurrentStepInfo()?.description}</span>
        <div className="tippy-footer">
            <span>{onboarding.currentStep} of {onboarding.getTotalSteps()}</span>
            <span className='tippy-btn' onClick={() => onboarding.incrementStep()}>Next</span>
        </div>
    </div>;
});

interface OnboardingTooltipProps {
    id: number;
    children: React.ReactNode;
}

export const OnboardingTooltip: React.FC<OnboardingTooltipProps> = observer(({id, children}) => {
    const {onboarding} = useStores();
    return (
        <Tippy
            content={<TooltipContent/>}
            visible={onboarding.currentStep === id}
            className='tippy-container'
            placement={onboarding.getCurrentStepInfo()?.arrowPlacement}
            arrow={true}
            interactive={true}
            theme="onboarding"
        >
            <div>
                {children}
            </div>
        </Tippy>
    );
});

interface BaseTooltipProps {
    children: React.ReactNode;
    isVisible: boolean;
}

const InfoTooltipContent: React.FC = () => {
    return (
        <div className='info-tooltip-content'>
            <div><span className='bold'>AI scan</span> <span className='not-bold'>- Show the overall probability of text to be ai-generated.</span>
            </div>
            <div><span className='bold'>Deep scan</span> <span className='not-bold'>- Get in depth analisys and know probability of AI for each sentence in the text.</span>
            </div>
            <div><span className='bold'>Plagiarism</span> <span className='not-bold'>- Quickly and accurately review all instances of plagiarised writing in your work. One word for plagiarism checking equal 2 words of ai-detection.</span>
            </div>
        </div>
    );
};

export const InfoTooltip: React.FC<BaseTooltipProps> = ({children, isVisible}) => {
    return (
        <Tippy 
            content={<InfoTooltipContent/>} 
            visible={isVisible} 
            className='tippy-container-white' 
            placement='bottom'
            arrow={true} 
            interactive={true}
            theme="info"
        >
            {children as any}
        </Tippy>
    );
};

interface TooltipProps {
    content: React.ReactNode;
    showButton?: boolean;
    visible?: boolean;
    placement?: Placement;
    title?: string;
    onClose?: () => void;
    children: React.ReactNode;
}

export const Tooltip: React.FC<TooltipProps> = ({children, content, showButton = true, visible = false, placement = 'top', title = '', onClose}) => {
    return (
        <Tippy
            visible={visible}
            content={<div>
                <div>
                    <div className="tippy-title">
                        <span>{title}</span>
                        <span style={{cursor: 'pointer'}} onClick={onClose}><Cross color={'white'}/></span>
                    </div>
                    <span className='tippy-description'>{content}</span>
                </div>
            </div>}
            className='tippy-container'
            placement={placement}
            arrow={true}
            interactive={true}
        >
            {children as any}
        </Tippy>
    );
}